import apiClient from "../config/apiClient";


export const fetchPaymentHistory = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=patient/${id}/transactions`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };

     // http://178.128.249.42:92/hmos/transactions?page=1&limit=15&patient_id=&startDate=&endDate=&status=0&hmo_id=&service_id=&admission_status=&is_opd=0